module.exports = __webpack_public_path__ + "img/ss／pic.56777186.png";